import {BreakpointObserver} from '@angular/cdk/layout';
import {ChangeDetectionStrategy, Component, inject, signal, ViewEncapsulation} from '@angular/core';
import {takeUntilDestroyed} from '@angular/core/rxjs-interop';
import {RouterOutlet} from '@angular/router';
import {AdminNavbarComponent} from './admin-navbar/admin-navbar.component';
import {AdminSidebarComponent} from './admin-sidebar/admin-sidebar.component';

@Component({
  selector: 'admin',
  imports: [RouterOutlet, AdminNavbarComponent, AdminSidebarComponent],
  template: `
    <div class="flex h-screen w-full flex-col overflow-hidden">
      <admin-navbar (sidebarToggle)="toggleSidebar()"></admin-navbar>
      <div class="bg-neutral-secondary-soft flex h-full overflow-hidden">
        <admin-sidebar [drawerVisible]="sidebarVisible()" (drawerHide)="sidebarVisible.set(false)"></admin-sidebar>
        <main class="h-auto flex-1 overflow-auto pt-16 md:ml-64">
          <router-outlet></router-outlet>
        </main>
      </div>
    </div>
  `,
  styleUrl: './admin.component.css',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminComponent {
  sidebarVisible = signal(false);

  constructor() {
    inject(BreakpointObserver)
      .observe('(min-width: 768px)')
      .pipe(takeUntilDestroyed())
      .subscribe(state => {
        if (state.matches) {
          this.sidebarVisible.set(false);
        }
      });
  }

  toggleSidebar() {
    this.sidebarVisible.update(v => !v);
  }
}
